import { PreferenceCpvDetailComponent } from './preferences-liste-cpv/preference-cpv-detail/preference-cpv-detail.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PreferencesAvisDePubComponent } from './preferences-avis-de-pub.component';
import { PreferenceDiffuseurDetailComponent } from './preferences-liste-diffusion/preference-diffuseur-detail/preference-diffuseur-detail.component';
import { PreferenceAcheteurPrincipalDetailComponent } from './preferences-acheteur-principal/preference-acheteur-principal-detail/preference-acheteur-principal-detail.component';


const routes: Routes = [
  { path: '', data:{ breadcrumb: 'breadcrumb.preferences'}, children: [
    { path: '', component: PreferencesAvisDePubComponent, data: { breadcrumb: null }, pathMatch: 'prefix' },
    { path: 'pref-cpv', component: PreferenceCpvDetailComponent, data: { action: 'ajouter', breadcrumb: 'breadcrumb.pref_add_cpv' } },
    { path: 'pref-cpv/:id', component: PreferenceCpvDetailComponent, data: { action: 'modifier', breadcrumb: 'breadcrumb.pref_modif_cpv' } },
    { path: 'pref-diffuseur', component: PreferenceDiffuseurDetailComponent, data: { action: 'ajouter', breadcrumb: 'breadcrumb.pref_add_diffuseur' } },
    { path: 'pref-diffuseur/:id', component: PreferenceDiffuseurDetailComponent, data: { action: 'modifier', breadcrumb: 'breadcrumb.pref_modif_diffuseur' } },
    { path: 'pref-acheteur-principal', component: PreferenceAcheteurPrincipalDetailComponent, data: { action: 'ajouter', breadcrumb: 'breadcrumb.pref_add_acheteur' } },
    { path: 'pref-acheteur-principal/:id', component: PreferenceAcheteurPrincipalDetailComponent, data: { action: 'modifier', breadcrumb: 'breadcrumb.pref_modif_acheteur' } },
  ]},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PreferencesRoutingModule { }
